export default __webpack_public_path__ + "93e9c47e8a7ba7b08cb1af52ed926b36.svg";